import React from 'react'

export default class IconsArrowUpAlternative extends React.Component {
    render() {
        let color = '#C8C5FE'
        if (this.props.color) color = this.props.color
        let className = 'icons-icon'
        return (
            <svg
                className={className}
                style={this.props.style}
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
            >
                <path
                    d='M3.33301 8.00004L7.99967 3.33337L12.6663 8.00004'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M8 12.6667V3.33337'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        )
    }
}
